import { isAConversationRoute } from 'dashboard/helper/routeHelpers';
import { frontendURL } from 'dashboard/helper/URLHelper';

import { isAutazoEmbeddedUser } from './useAutazoEmbeddedAccess';

const AUTAZO_EMBEDDED_PROHIBITED_CONVERSATION_ROUTES = new Set([
  'folder_conversations',
  'conversations_through_folders',
]);

/**
 * AUTAZO INTEGRATION: this pure guard runs only after upstream authentication,
 * Account resolution, onboarding handling, and active/permission validation.
 * Keeping that order preserves login, no_accounts, and suspended Account flows.
 * See docs/autazo-integration/03-frontend-conversations-only.md.
 */
export const getAutazoEmbeddedRedirect = ({ to, user }) => {
  if (!isAutazoEmbeddedUser(user)) return null;

  const routeAccountId = Number(to.params?.accountId || user.account_id);
  const authorizedAccount = user.accounts?.find(
    account => account.id === routeAccountId
  );

  if (!authorizedAccount || authorizedAccount.status !== 'active') return null;

  const isAllowedConversationRoute =
    isAConversationRoute(to.name, true, true) &&
    !AUTAZO_EMBEDDED_PROHIBITED_CONVERSATION_ROUTES.has(to.name);

  if (isAllowedConversationRoute) return null;

  return frontendURL(`accounts/${authorizedAccount.id}/dashboard`);
};
